module.exports = __webpack_public_path__ + "static/media/marketing.5c63e7df.png";